import axios from "../../config/axiosConfig";
import { 
    GET_REPORT_MASTER_DETAIL, 
    REPORT_MASTER_DETAIL_REQUEST, 
    REPORT_MASTER_DETAIL_REQUEST_SUCCESS, 
    REPORT_MASTER_DETAIL_REQUEST_FAILURE,
    GET_REPORT_MASTER_WITH_DETAIL, 
    REPORT_MASTER_WITH_DETAIL_REQUEST, 
    REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS, 
    REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE,  
} from "../types";

export const getReportMasterDetail = (params) => {
    return async(dispatch, getState) => {
        try{
            dispatch({type: REPORT_MASTER_DETAIL_REQUEST})
            const { auth } = getState();
            const defaultParams = {
                // userId: auth.user?.id,
                // finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/report-master-detail/getAll?${queryString}`;
            return axios.get(fullUrl).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_REPORT_MASTER_DETAIL, payload: response.data });
                    dispatch({ type: REPORT_MASTER_DETAIL_REQUEST_SUCCESS });
                } else {
                    dispatch({ type: REPORT_MASTER_DETAIL_REQUEST_FAILURE });
                }
                return response.data;
            }).catch((error) => {
                console.error("Error fetching Report Master:", error);
                dispatch({ type: REPORT_MASTER_DETAIL_REQUEST_FAILURE, error: error.message });
            });
        }
        catch(error){
            console.error("Error fetching Report Master:", error);
            dispatch({ type: REPORT_MASTER_DETAIL_REQUEST_FAILURE, error: error.message });
        }
    }
};

export const getReportMasterWithDetail = (params) => {
    return async(dispatch, getState) => {
        try{
            dispatch({type: REPORT_MASTER_WITH_DETAIL_REQUEST})
            const { auth } = getState();
            const defaultParams = {
                // userId: auth.user?.id,
                // finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/report-master-detail/getAllReportMasterWithDetails?${queryString}`;
            return axios.get(fullUrl).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_REPORT_MASTER_WITH_DETAIL, payload: response.data });
                    dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS });
                } else {
                    dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE });
                }
                return response.data;
            }).catch((error) => {
                console.error("Error fetching Report Master:", error);
                dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE, error: error.message });
            });
        }
        catch(error){
            console.error("Error fetching Report Master:", error);
            dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE, error: error.message });
        }
    }
};

export const getReportMasterWithDetailForSaleWithChallan = (params) => {
    return async(dispatch, getState) => {
        try{
            dispatch({type: REPORT_MASTER_WITH_DETAIL_REQUEST})
            const { auth } = getState();
            const defaultParams = {
                // userId: auth.user?.id,
                // finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/report-master-detail/getAllReportMasterWithDetails?${queryString}`;
            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                    dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS });
                } else {
                    dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE });
                }
                return response.data;
            }).catch((error) => {
                console.error("Error fetching Report Master:", error);
                dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE, error: error.message });
            });
        }
        catch(error){
            console.error("Error fetching Report Master:", error);
            dispatch({ type: REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE, error: error.message });
        }
    }
};
